export const FEEDBACK_TEXTS = {
  thanks: "Thank you for your order!",
  processing:
    "Your order is now processing, and we will reach out if we need any additional information.",
  additional:
    "You will receive an additional email to let you know when your gift has been delivered. Order details will also be available in your Order History.",
  receipt: `Your order receipt was sent to `,
  orders:
    "Most orders are processed immediately, but please allow up to 24 hours. Delivery times may vary for each gift card in a single order.",
  giftDesc:
    "The recipient will receive the gift once your order has been processed. We'll notify you when the gift has been accessed. In the meantime, feel free to let the recipient know that there is a gift coming their way!"
};
